import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';

export const MissingShop = styled.div`
  text-transform: none;
  font-weight: normal;
  font-size: ${layout.measurements.fontSizeSmall};
  margin: ${layout.measurements.spacing100};
  align-self: flex-end;
`;

export const ModalButton = styled.button`
  color: ${props => props.theme.text.linkExternal};
  cursor: pointer;
  text-decoration: underline;
  font-weight: 600;

  &:hover {
    color: ${p => p.theme.text.linkExternalHover};
  }
`;
